import React from 'react';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';

const PersonalInfoTab = ({ userRole, formData, errors, onChange, onSave, isSaving }) => {
  const countryOptions = [
    { value: 'nl', label: 'Nederland' },
    { value: 'be', label: 'België' },
    { value: 'de', label: 'Duitsland' }
  ];

  const genderOptions = [
    { value: 'male', label: 'Man' },
    { value: 'female', label: 'Vrouw' },
    { value: 'other', label: 'Anders' },
    { value: 'prefer_not_to_say', label: 'Zeg ik liever niet' }
  ];

  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-xl md:text-2xl font-semibold text-foreground mb-4">
          Persoonlijke Gegevens
        </h3>
        <p className="text-sm md:text-base text-muted-foreground mb-6">
          Beheer uw persoonlijke informatie en contactgegevens
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
        <Input
          label="Voornaam"
          type="text"
          placeholder="Voer uw voornaam in"
          value={formData?.firstName}
          onChange={(e) => onChange('firstName', e?.target?.value)}
          error={errors?.firstName}
          required
        />

        <Input
          label="Achternaam"
          type="text"
          placeholder="Voer uw achternaam in"
          value={formData?.lastName}
          onChange={(e) => onChange('lastName', e?.target?.value)}
          error={errors?.lastName}
          required
        />

        <Input
          label="E-mailadres"
          type="email"
          placeholder="voorbeeld@email.nl"
          value={formData?.email}
          onChange={(e) => onChange('email', e?.target?.value)}
          error={errors?.email}
          required
          description="Dit is uw primaire contactemail"
        />

        <Input
          label="Telefoonnummer"
          type="tel"
          placeholder="+31 6 12345678"
          value={formData?.phone}
          onChange={(e) => onChange('phone', e?.target?.value)}
          error={errors?.phone}
          required
        />

        <Input
          label="Geboortedatum"
          type="date"
          value={formData?.birthDate}
          onChange={(e) => onChange('birthDate', e?.target?.value)}
          error={errors?.birthDate}
        />

        <Select
          label="Geslacht"
          options={genderOptions}
          value={formData?.gender}
          onChange={(value) => onChange('gender', value)}
          placeholder="Selecteer geslacht"
        />
      </div>
      <div className="border-t border-border pt-6">
        <h4 className="text-lg md:text-xl font-medium text-foreground mb-4">
          Adresgegevens
        </h4>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
          <div className="md:col-span-2">
            <Input
              label="Straatnaam en huisnummer"
              type="text"
              placeholder="Hoofdstraat 123"
              value={formData?.street}
              onChange={(e) => onChange('street', e?.target?.value)}
              error={errors?.street}
              required
            />
          </div>

          <Input
            label="Postcode"
            type="text"
            placeholder="1234 AB"
            value={formData?.postalCode}
            onChange={(e) => onChange('postalCode', e?.target?.value)}
            error={errors?.postalCode}
            required
            description="Nederlandse postcode formaat"
          />

          <Input
            label="Plaats"
            type="text"
            placeholder="Amsterdam"
            value={formData?.city}
            onChange={(e) => onChange('city', e?.target?.value)}
            error={errors?.city}
            required
          />

          <Select
            label="Land"
            options={countryOptions}
            value={formData?.country}
            onChange={(value) => onChange('country', value)}
            required
          />

          {(userRole === 'client' || userRole === 'affiliate') && (
            <Input
              label="KVK-nummer"
              type="text"
              placeholder="12345678"
              value={formData?.kvkNumber}
              onChange={(e) => onChange('kvkNumber', e?.target?.value)}
              error={errors?.kvkNumber}
              description="Kamer van Koophandel registratienummer"
            />
          )}
        </div>
      </div>
      {userRole === 'client' && (
        <div className="border-t border-border pt-6">
          <h4 className="text-lg md:text-xl font-medium text-foreground mb-4">
            Bedrijfsinformatie
          </h4>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
            <Input
              label="Bedrijfsnaam"
              type="text"
              placeholder="Uw bedrijfsnaam"
              value={formData?.companyName}
              onChange={(e) => onChange('companyName', e?.target?.value)}
              error={errors?.companyName}
              required
            />

            <Input
              label="BTW-nummer"
              type="text"
              placeholder="NL123456789B01"
              value={formData?.vatNumber}
              onChange={(e) => onChange('vatNumber', e?.target?.value)}
              error={errors?.vatNumber}
            />

            <div className="md:col-span-2">
              <Input
                label="Website"
                type="url"
                placeholder="https://www.uwbedrijf.nl"
                value={formData?.website}
                onChange={(e) => onChange('website', e?.target?.value)}
                error={errors?.website}
              />
            </div>
          </div>
        </div>
      )}
      <div className="flex justify-end pt-4">
        <Button
          variant="default"
          onClick={onSave}
          loading={isSaving}
          iconName="Save"
          iconPosition="left"
        >
          Wijzigingen opslaan
        </Button>
      </div>
    </div>
  );
};

export default PersonalInfoTab;